import React from 'react';
import CableInsulationReport from '../CommissioningCableInsulation/CableInsulationReport';

// Thin wrapper around the shared cable-insulation report, fixed to the pre-insulation variant.
export default function CommissioningCablePreInsulationReport (props) {
  return <CableInsulationReport variant='pre' {...props} />;
}
